const partners = {
  state: [
    {
      name: 'Ferrum Network',
      src: require('@/assets/img/ferrum.png'),
      website: 'https://ferrum.network/',
      height: '100px',
      width: 'auto',
    },
    {
      name: 'Bridge Private Equality Inc',
      src: require('@/assets/img/BPE_logo.png'),
      website: 'https://bridgecryptoinc.com',
      height: '100px',
      width: 'auto',
    },
    {
      name: 'Moon Mafia Capital',
      src: require('@/assets/img/MM_logo.png'),
      website: '',
      height: '100px',
      width: '180px',
    },
  ],
}
export default partners
